module.exports = __webpack_public_path__ + "img/male.53d25214.svg";